<template>
    <Section width="md">
        <div class="container">
            <h2>{{ slice.primary.h2 }}</h2>
            <div 
                v-if="$validateText(slice.primary.text)" 
                class="rich-text" 
                v-html="$prismic.asHtml(slice.primary.text)" 
            />
            <div class="card-container">
                <div 
                    v-for="(author, index) in authors" 
                    :key="index"
                    class="card" 
                >
                    <div class="card-header">
                        <prismic-image 
                            class="card-header-image"
                            :img="author.data.image" 
                            :alt="author.data.alt"
                            w="70"
                            h="70"    
                        />
                        <div class="card-header-info">
                            <nuxt-link :to="$prismic.linkResolver(author)" class="card-header-name">
                                {{ author.data.name }}
                            </nuxt-link>
                            <a
                                class="card-header-email rich-text"
                                :href="`mailto:${author.data.email}`"    
                            >
                                <i class="fas fa-envelope" />
                                {{ author.data.email }}
                            </a>
                        </div>
                    </div>
                    <div class="card-body rich-text" v-html="$prismic.asHtml(author.data.bio)" />
                </div>
            </div>
        </div>
    </Section>
</template>
<script>
export default {
    props: {
        slice: {
            type: Object,
            required: true
        }
    },
    computed: {
        authors() {
            return this.$store.state.authors;
        }
    }
};
</script>
<style lang='scss' scoped>
    .container {
        .card-container {
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            @include device(pad) {
                grid-template-columns: repeat(2, 1fr);
            }
            gap: 2rem;
            margin-top: 2rem;
                .card {
                    gap: 0.5rem;
                    display: flex;
                    flex-direction: column;
                    @include spacing(padding, 5);
                    box-shadow: 0 0.375rem 1.5rem 0 rgba(140, 152, 164, .125);
                    .card-header {
                        display: flex;
                        gap: 0.5rem;
                        .card-header-image {
                            border-radius: 50%;
                        }
                        .card-header-info {
                            font-family: $fontHeader;
                            display: flex;
                            flex-wrap: wrap;
                            gap: 0.5rem;
                            flex-direction: column;
                            justify-content: center;
                            .card-header-name {
                                @include font-size(24px);
                                color: $font;
                                font-weight: bold;
                                &:hover {
                                    color: $pink;
                                    text-decoration: underline;
                                }
                            }
                            .card-header-email {
                                display: flex;
                                align-items: center;
                                word-break: break-word;
                                flex-wrap: wrap;
                                color: #677788;
                                &:hover {
                                    color: $pink;
                                }
                                i {
                                    color: $pink;
                                    margin-right: 10px;
                                }
                            }
                            
                        }
                    }
                    .card-body::v-deep {
                        border-top: .0625rem solid rgba(33, 50, 91, .1);
                        padding-top: 1rem;
                        p:first-child {
                            margin-top: 0;                            
                        }
                    }
                }
        }
    }
</style>